<template>
  <v-app>
    <v-toolbar color="green lighten-2" app>
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-side-icon></v-toolbar-side-icon>
    </v-toolbar>
    <v-content>
      <v-container fluid ma-0 pa-0 fluid ma-0 pa-0 fill-height>
        <v-container>
            <router-view />
        </v-container>
      </v-container>
    </v-content>
     <v-bottom-nav app
      active.sync=1
      value="true"
      absolute
      color="green"
    >
    </v-bottom-nav>
  </v-app>
</template>
<script>
export default {
  name: 'glpm',
  components: {
  },
  data () {
    return {
      title: "ФБУ РОСЛЕСОЗАЩИТА. ГЛПМ"
    }
  },
  mounted: function () {
    
  },
  computed: {
  },
  methods: {
  },
  watch: {
  }
}
</script>